import { SidebarMenuItem } from './SidebarMenuItem';
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub';
import { useAuth } from '../../../../../app/modules/auth';
import { getDashboardPath } from '../../../../../app/utils/helper';

function getIconByTitle(title) {
  const iconMapping = {
    "Dashboard": { icon: "home", fontIcon: "home" },
    "PayAiro Users": { icon: "people", fontIcon: "people" },
    "User Management": { icon: "user", fontIcon: "user" },
    "Role Management": { icon: "focus", fontIcon: "focus" },
    "Transactions": { icon: "credit-cart", fontIcon: "credit-cart" },
    "Set Limits": { icon: "more-2", fontIcon: "settings-4" },
    "Fee Settings": { icon: "wallet", fontIcon: "wallet" },
    "Announcements": { icon: "notification-circle", fontIcon: "notification-circle" },
    "Support": { icon: "message-notif", fontIcon: "message-notif" },
    "Settings": { icon: "gear", fontIcon: "gear" },
  };

  return iconMapping[title] || { icon: "question-circle", fontIcon: "question-circle" };
}

export function SidebarMenuMain() {
  const { currentUser, auth } = useAuth();
  const role = currentUser?.role || auth?.role || currentUser?.user_type;
  const userType = currentUser?.user_type || auth?.user_type;
  const dashboardPath = getDashboardPath(role, currentUser?.user_type);

  const isCustomerSupport =
    role === 'CUSTOMER_SUPPORT' ||
    role === 'CustomerSupport' ||
    userType === 'CustomerSupport';

  const isSpectator =
    role === 'Spectator' ||
    userType === 'Spectator';

  const isManager =
    role === 'Manager' ||
    userType === 'Manager';

  // Spectator & Manager: same menu as Spectator (no User Management / Set Limits / Fee Settings)
  const isSpectatorLike = isSpectator || isManager;

  // Treat every non-customer-support user (except Spectator & Manager) as admin menu scope.
  const isAdmin = !isCustomerSupport && !isSpectatorLike;

  return (
    <>
      {/* Dashboard Link */}
      <SidebarMenuItem title="Dashboard" to={dashboardPath} {...getIconByTitle("Dashboard")} />

      {/* User Management Link - Admin only (Spectator sees PayAiro Users directly below) */}
      {isAdmin && (
        <SidebarMenuItemWithSub title="User Management" to="/user-management" {...getIconByTitle("User Management")}>
          <SidebarMenuItem title="All Users" to="/all-users" icon="fasten" />
          <SidebarMenuItem title="Role Management" to="/role-management" icon="focus" />
          <SidebarMenuItem title="PayAiro Users" to="/payairo-users" icon="focus" />
        </SidebarMenuItemWithSub>
      )}

      {/* Support Performance - Admin only */}
      {isAdmin && (
        <SidebarMenuItem title="Support Performance" to="/admin/support-performance" {...getIconByTitle("User Management")} />
      )}
      
      {/* Support Performance - Manager only */}
      {isManager && (
        <SidebarMenuItem title="Support Performance" to="/manager/support-performance" {...getIconByTitle("User Management")} />
      )}

      {/* Transactions - Admin, Spectator, Manager, and Customer Support */}
      {(isAdmin || isSpectatorLike || isCustomerSupport) && (
        <SidebarMenuItemWithSub title="Transactions" to="/transactions/fiat" {...getIconByTitle("Transactions")}>
          <SidebarMenuItem title="Fiat Transactions" to="/transactions/fiat" icon="fasten" />
          <SidebarMenuItem title="Crypto Transactions" to="/transactions/crypto" icon="fasten" />
          <SidebarMenuItem title="Withdraw History" to="/transactions/withdraw" icon="focus" />
        </SidebarMenuItemWithSub>
      )}

      {/* Announcements Link - Admin, Spectator, Manager, and Customer Support */}
      {(isAdmin || isSpectatorLike || isCustomerSupport) && (
        <SidebarMenuItem title="Announcements" to="/announcements" {...getIconByTitle("Announcements")} />
      )}

      {/* Role Management — Manager only (create Spectator / Customer Support) */}
      {isManager && (
        <SidebarMenuItem title="Role Management" to="/role-management" {...getIconByTitle("Role Management")} />
      )}

      {/* PayAiro Users - Top level for Spectator & Manager */}
      {isSpectatorLike && (
        <SidebarMenuItem title="PayAiro Users" to="/payairo-users" {...getIconByTitle("PayAiro Users")} />
      )}

      {/* Fees & Limits - Admin only */}
      {isAdmin && (
        <>
          <SidebarMenuItem title="Set Limits" to="/set-limits" {...getIconByTitle("Set Limits")} />
          <SidebarMenuItem title="Fee Settings" to="/fee-settings" {...getIconByTitle("Fee Settings")} />
        </>
      )}

      {/* PayAiro Users - Customer Support only */}
      {isCustomerSupport && (
        <SidebarMenuItem title="PayAiro Users" to="/customer-support/payairo-users" {...getIconByTitle("PayAiro Users")} />
      )}

      {/* Support Link - Admin, Spectator, Manager, and Customer Support */}
      {(isAdmin || isSpectatorLike || isCustomerSupport) && <SidebarMenuItem title="Support" to="/support" {...getIconByTitle("Support")} />}

      {/* Settings Link - Admin, Spectator, Manager, and Customer Support */}
      {(isAdmin || isSpectatorLike || isCustomerSupport) && <SidebarMenuItem title="Settings" to="/settings" {...getIconByTitle("Settings")} />}
    </>
  );
}
